import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './FloatingBuyButton.css';

export default function FloatingBuyButton() {
  const [pastThreshold, setPastThreshold] = useState(false); // has the user scrolled far enough?
  const [isScrolling, setIsScrolling] = useState(false);     // is the user actively scrolling?
  const location = useLocation();
  const scrollTimerRef = useRef(null);

  // ── Step 1: Determine if we're past the visibility threshold ──────────────
  useEffect(() => {
    // On non-home pages: always past threshold immediately
    if (location.pathname !== '/') {
      setPastThreshold(true);
      return;
    }

    // On homepage: show only after scrolling past #marquee-trust
    const checkThreshold = () => {
      const marquee = document.getElementById('marquee-trust');
      if (!marquee) { setPastThreshold(false); return; }
      setPastThreshold(marquee.getBoundingClientRect().bottom < 0);
    };

    checkThreshold();
    window.addEventListener('scroll', checkThreshold, { passive: true });
    return () => window.removeEventListener('scroll', checkThreshold);
  }, [location.pathname]);

  // ── Step 2: Hide while scrolling, reappear 600ms after scroll stops ───────
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolling(true);
      if (scrollTimerRef.current) clearTimeout(scrollTimerRef.current);
      scrollTimerRef.current = setTimeout(() => {
        setIsScrolling(false);
      }, 600);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimerRef.current) clearTimeout(scrollTimerRef.current);
    };
  }, []);

  // Visible only when: past threshold AND not actively scrolling
  const visible = pastThreshold && !isScrolling;

  return (
    <a
      href="/#product-showcase"
      className={`floating-buy-btn${visible ? ' floating-buy-btn--visible' : ''}`}
      aria-label="Buy Now, Playermaker 2.0"
    >
      BUY NOW
    </a>
  );
}
